import React, { Component } from 'react';
import Tibbit_base from '@appblocks/frontend/client/Components/TPP/Tibbit_base';


export default class Tibbit_module_narrow extends Tibbit_base {
    constructor(props: any) {
        super(props);
        this.width = 101.879;
        this.height = 48.896;
    }

    render() {
        return (
            <g {...this.props} className="tibbit">
                <rect className="draggable" x="0" y="0" width="101.879" height="48.896" />

                <g id="body">
                    <rect id="color" className={`moduleColor_${this.props.category}`} x="0" y="0" width="101.879" height="48.896" />

                    <path className="recess" d="M9.731,45.505h-9.73V3.391h9.73v4.124h-5.27v2.819h5.27v4.938h-5.27v2.82h5.27v4.95h-5.27v2.819h5.27v4.929h-5.27v2.819&#10;&#9;&#9;h5.27v4.865h-5.27v2.819h5.27V45.505z M92.152,3.391v4.124h5.26v2.819h-5.26v4.938h5.26v2.82h-5.26v4.94h5.26v2.819h-5.26v4.938&#10;&#9;&#9;h5.26v2.819h-5.26v4.865h5.26v2.819h-5.26v4.21h5.26h4.469V3.391H92.152z" />

                    <polygon transform="rotate(-90 24.448 24.448)" className="labelColor" points="3.4,87.872 45.507,87.882 45.517,22.652 37.067,13.992 3.391,14.001 " />

                    <rect className="tibbitStroke" x="0" y="0" width="101.879" height="48.896" />
                </g>

                <g id="label">
                    <text transform="matrix(1 0 0 1 20.8613 17)" className="label">{this.props.num}</text>
                    <text transform="matrix(1 0 0 1 21.2163 28.2717)" className="desc" id="desc">
                        {this.renderDescriptions()}
                    </text>
                </g>
                <g id="lines">
                    {this.renderLines()}
                </g>
                {/* <image xlinkHref={"https://docs.tibbo.com/phm/label-" + this.props.num.replace('#', '') + ".png"}
                    x={3} y={3} width={this.width - 8} height={this.height - 6} /> */}
                {this.renderWiring()}
            </g>
        );
    }
}
